import {
  exportSnapshot,
  restoreSnapshot,
} from "@/services/api/app/google/recovery/classroom/data-set/wholeClass";

const defaultState = () => ({})

export default {
  namespaced: true,

  actions: {
    exportSnapshot({commit}, data) {
      return exportSnapshot({
        ...data,
        dataType: '16'
      });
    },
    restoreSnapshot({commit}, data) {
      return restoreSnapshot(data);
    },
  },

  mutations: {},

  state: defaultState
}
